import { Badge } from '@/components/ui/badge';
import { buildOutcomeDisplay, useEffectiveOutcomes } from '@/hooks/useOutcomes';

/**
 * Badge for a (dynamic) call outcome key. Colors and labels come from the
 * outcome_definitions vocabulary; unknown/legacy keys fall back to the static
 * badge map and a prettified key. Renders nothing when there is no outcome.
 */
export function OutcomeBadge({
  outcome,
  className = '',
}: {
  outcome: string | null | undefined;
  className?: string;
}) {
  // Shared react-query cache — one fetch per page regardless of badge count.
  const { data: definitions } = useEffectiveOutcomes();

  if (!outcome) return null;

  const display = buildOutcomeDisplay(definitions);
  return (
    <Badge variant="outline" className={`${display.badgeClass(outcome)} ${className}`.trim()}>
      {display.label(outcome)}
    </Badge>
  );
}

/**
 * Non-Badge variant for call rows that style the pill themselves — returns
 * the color classes + label for an outcome key.
 */
export function useOutcomeDisplay() {
  const { data: definitions } = useEffectiveOutcomes();
  return buildOutcomeDisplay(definitions);
}
